module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#news",
      toString: function () {
        return this.url;
      }
    }